import { Component, computed, inject, effect, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { SECTIONS } from '@anessa/shared-models';
import { provideI18nScope } from '../../shared/i18n/i18n-scope.provider';
import { I18nScopedService } from '../../shared/i18n/i18n-scoped.service';
import { I18nPipe } from '../../shared/i18n/i18n-pipe';
import { I18nScopeReadyDirective } from '../../shared/i18n/i18n-scope-ready.directive';
import { DashboardService } from '../dashboard/services/dashboard/dashboard.service';
import { Router } from '@angular/router';
import { DashboardListItem } from '../dashboard/models/dashboard-list-item/dashboard-list-item.model';
import { PermissionService } from '../../shared/services/permissions/permission.service';
import { AddDashboardService } from '../../ui/dashboard/add-dashboard-dialog/add-dashboard.service';
import { EmptyStateCard } from '../../shared/common/empty-state-card/empty-state-card';

@Component({
  selector: 'app-dashboards-landing',
  imports: [
    I18nPipe,
    I18nScopeReadyDirective,
    MatButtonModule,
    MatIconModule,
    EmptyStateCard,
  ],
  templateUrl: './dashboards-landing.html',
  styleUrl: './dashboards-landing.scss',
  providers: [
    provideI18nScope('features/dashboards-landing'),
    I18nScopedService,
  ],
})
export class DashboardsLanding {
  private readonly dashboardService = inject(DashboardService);
  private readonly router = inject(Router);
  private readonly permissionService = inject(PermissionService);
  private readonly addDashboardService = inject(AddDashboardService);
  dashboards: DashboardListItem[] = [];
  loading = signal<boolean>(true);

  // Same gate as the sidebar's "+".
  readonly canEdit = computed(() =>
    this.permissionService.canEditSection(SECTIONS.DASHBOARDS),
  );

  constructor() {
    effect(() => {
      const loaded = this.dashboardService.dashboardListLoaded();
      const allDashboards = this.dashboardService.dashboardList();

      if (!loaded) return;

      this.dashboards = allDashboards;
      this.loading.set(false);

      if (this.dashboards.length > 0) {
        void this.router.navigateByUrl('/dashboard/' + this.dashboards[0].id);
      }
    });
  }

  createDashboard(): void {
    this.addDashboardService.open();
  }
}
